import { getKey, useEvent, useId, useWindowEvent, windowObject } from '@fold-dev/core'
import React, { ReactElement, createContext, useState } from 'react'
import { LabelSelectLabel, TodoTaskItem, UserSelectUser } from '../'
import { FOLD_TODO_SHIFT_FLAG } from './'
import { TodoSectionHeader, TodoSectionHeaderProps } from './todo-section-header'
import { TodoTaskProps } from './todo-task'
import { useTodoEvent } from './todo.util'

export type TodoProviderProps = {
    id?: string
    // tasks
    onTaskOpen: (value) => void
    onTaskUpdate: (value) => void
    onTaskTitleUpdate: (value) => void
    onTaskLabelAdd: (value) => void
    onTaskLabelDelete: (value) => void
    onTaskDateUpdate: (value) => void
    onTaskUserAdd: (value) => void
    onTaskUserDelete: (value) => void
    onTaskComplete: (value) => void
    onTaskAdd: (value) => void
    onMultipleTaskAdd?: (value) => void
    onTaskAddBelow: (value) => void
    onTaskAddAbove: (value) => void
    onTaskMove: (value) => void
    onTaskMoveToProject: (value) => void
    // sections
    onSectionDelete: (value) => void
    onSectionUpdate: (value) => void
    onSectionAdd: (value) => void
    onSectionMove: (value) => void
    // visual
    noProjectPrefix?: boolean
    noSectionAdd?: boolean
    noSectionEdit?: boolean
    noTaskLabels?: boolean
    noTaskUsers?: boolean
    noTaskDates?: boolean
    noSelection?: boolean
    noDragging?: boolean
    noIndent?: boolean
    noBlankSection?: boolean
    kanbanMode?: boolean
    showProjectName?: boolean
    fields?: any
    // react
    children: ReactElement
}

export const TodoContext = createContext<any>({})

export const TodoProvider = (props: TodoProviderProps) => {
    const {
        id,
        onTaskOpen,
        onTaskUpdate,
        onTaskTitleUpdate,
        onTaskLabelAdd,
        onTaskLabelDelete,
        onTaskDateUpdate,
        onTaskUserAdd,
        onTaskUserDelete,
        onTaskComplete,
        onTaskAdd,
        onMultipleTaskAdd,
        onTaskAddBelow,
        onTaskAddAbove,
        onTaskMove,
        onTaskMoveToProject,
        onSectionDelete,
        onSectionUpdate,
        onSectionAdd,
        onSectionMove,
        noProjectPrefix,
        noSectionAdd,
        noSectionEdit,
        noTaskLabels,
        noTaskUsers,
        noTaskDates,
        noSelection,
        noDragging,
        noIndent,
        noBlankSection,
        kanbanMode,
        showProjectName,
        fields,
        children,
    } = props
    const instanceId = useId(id)
    const iid = instanceId
    const [nested, setNested] = useState(false)
    const [selection, setSelection] = useState({})
    const [isShift, setIsShift] = useState(false)

    const handleKeyUp = (e) => {
        setIsShift(false)
        windowObject[FOLD_TODO_SHIFT_FLAG] = false
    }

    const hanleKeyDown = (e) => {
        const { isShift, isBackspace, isEscape, isMeta } = getKey(e)
        const shift = isShift && !isMeta

        setIsShift(shift)
        windowObject[FOLD_TODO_SHIFT_FLAG] = shift

        if (isEscape) setSelection({})
        if (isBackspace) setSelection({})
    }

    const handleSelectTasks = ({ detail: { instanceId, ...rest } }) => {
        if (iid == instanceId) setSelection({ ...rest })
    }

    useTodoEvent('select', handleSelectTasks)

    useWindowEvent('keydown', hanleKeyDown)
    useEvent('keyup', handleKeyUp)

    return (
        <TodoContext.Provider
            value={{
                selection,
                setSelection,
                nested,
                setNested,
                instanceId,
                onTaskOpen,
                onTaskUpdate,
                onTaskTitleUpdate,
                onTaskLabelAdd,
                onTaskLabelDelete,
                onTaskDateUpdate,
                onTaskUserAdd,
                onTaskUserDelete,
                onTaskComplete,
                onTaskAdd,
                onMultipleTaskAdd,
                onTaskAddBelow,
                onTaskAddAbove,
                onTaskMove,
                onTaskMoveToProject,
                onSectionDelete,
                onSectionUpdate,
                onSectionAdd,
                onSectionMove,
                noProjectPrefix,
                noSectionAdd,
                noSectionEdit,
                noTaskLabels,
                noTaskUsers,
                noTaskDates,
                noSelection,
                noIndent,
                noDragging,
                noBlankSection,
                kanbanMode,
                showProjectName,
                fields,
            }}>
            {children}
        </TodoContext.Provider>
    )
}
